<div class="ticket-quality">
  <div class="quality-list-header">
    <span class="quality-count">
      <i class="pi pi-list-check text-sm"></i>
      {{ publications().length }} publicação(s)
    </span>
    @if (canWrite) {
      <p-button
        icon="pi pi-plus"
        label="Nova Publicação"
        size="small"
        (click)="openNew()"
        [disabled]="loading()" />
    }
  </div>

  @if (loading() && publications().length === 0) {
    <div class="loading-state">
      <p-skeleton height="72px" styleClass="mb-2" />
      <p-skeleton height="72px" styleClass="mb-2" />
      <p-skeleton height="72px" />
    </div>
  }

  @if (!loading() && publications().length === 0) {
    <div class="empty-state">
      <i class="pi pi-list-check"></i>
      <p>Nenhuma publicação de qualidade cadastrada</p>
    </div>
  }

  @if (publications().length > 0) {
    <div class="quality-list">
      @for (pub of publications(); track pub.id) {
        <div class="quality-item">
          <div class="quality-top">
            <div class="quality-content">
              <div class="quality-main-row">
                <span class="quality-title">{{ pub.titulo || '(Sem título)' }}</span>
              </div>
              <div class="quality-badges-row">
                @if (pub.publicar) {
                  <p-tag icon="pi pi-eye" value="Publicado" severity="success" size="small" />
                } @else {
                  <p-tag icon="pi pi-eye-slash" value="Não publicado" severity="secondary" size="small" />
                }
                @if (pub.ticket_status?.description) {
                  <p-tag [value]="pub.ticket_status!.description" severity="secondary" size="small" />
                }
              </div>
              @if (getTags(pub.tags).length > 0) {
                <div class="quality-tags-row">
                  @for (tag of getTags(pub.tags); track tag) {
                    <p-tag [value]="tag" severity="info" size="small" />
                  }
                </div>
              }
              @if (pub.descricao) {
                <div class="quality-desc-row">{{ pub.descricao }}</div>
              }
            </div>
            @if (canWrite) {
              <div class="quality-actions">
                <p-button
                  icon="pi pi-pencil"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  severity="secondary"
                  pTooltip="Editar publicação"
                  tooltipPosition="top"
                  (click)="edit(pub)" />
                <p-button
                  icon="pi pi-trash"
                  [text]="true"
                  [rounded]="true"
                  size="small"
                  severity="danger"
                  pTooltip="Excluir publicação"
                  tooltipPosition="top"
                  (click)="delete(pub)" />
              </div>
            }
          </div>
          @if (pub.data || pub.user?.name) {
            <div class="quality-meta-row">
              @if (pub.user?.name) {
                <span>
                  <i class="pi pi-user"></i>
                  {{ pub.user!.name }}
                </span>
              }
              @if (pub.data) {
                <span class="quality-meta-right">
                  <i class="pi pi-calendar"></i>
                  {{ formatDate(pub.data) }}
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<app-quality-form
  #qualityForm
  (onSave)="onSaved()">
</app-quality-form>
